import * as React from 'react';

type PlayArrowProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const PlayArrow: React.FC<PlayArrowProps> = ({
  width = 96,
  height = 96,

  ...props
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M32 68.6998V27.2998C32 26.1665 32.4 25.2165 33.2 24.4498C34 23.6831 34.9333 23.2998 36 23.2998C36.3333 23.2998 36.6833 23.3498 37.05 23.4498C37.4167 23.5498 37.7667 23.6998 38.1 23.8998L70.7 44.5998C71.3 44.9998 71.75 45.4998 72.05 46.0998C72.35 46.6998 72.5 47.3331 72.5 47.9998C72.5 48.6665 72.35 49.2998 72.05 49.8998C71.75 50.4998 71.3 50.9998 70.7 51.3998L38.1 72.0998C37.7667 72.2998 37.4167 72.4498 37.05 72.5498C36.6833 72.6498 36.3333 72.6998 36 72.6998C34.9333 72.6998 34 72.3165 33.2 71.5498C32.4 70.7831 32 69.8331 32 68.6998Z"
        fill="white"
      />
    </svg>
  );
};

export default PlayArrow;
